import React from "react";
import journeyLine from "../../assets/journey-line.svg";
import ScrollAnimation from "react-animate-on-scroll";

const Journey = () => {
  return (
    <>
      <section className="pt-10 md:pt-20 pb-12 md:pb-24 bg-Gray-50">
        <div className="container sm:container md:container lg:container w-full mx-auto">
          <h2 className="brand-secondary-gradient text-4xl font-semibold leading-normal mb-5 md:mb-10 md:text-left text-center">
            #journey
          </h2>
          <div className="journey-list md:mt-12 lg:mt-24">
            <div className="grid grid-cols-1  md:grid-cols-5 gap-4 md:px-0 px-6 lg:hidden md:hidden block">
              <div className="rounded-lg bg-white my-2 px-6 py-4 shadow-xl border border-Gray-150">
                <div className="pointer-blue pointer-1">
                  <h4 className="font-avenirBook text-Gray-900 text-base">
                    2001
                  </h4>
                  <h4 className="font-avenirBook text-Gray-900 text-lg">
                    <span className="font-avenirHeavy">2M</span>Nordic
                  </h4>
                  <p className="text-sm text-Gray-400 pt-1 font-opensans">
                    Company has been founded by{" "}
                    <span className="font-bold">Marius</span> and{" "}
                    <span className="font-bold">Mihai</span> in Helsinborg.
                  </p>
                </div>
              </div>
              <div className="rounded-lg bg-white my-2 px-6 py-4 shadow-xl border border-Gray-150 mobile-line-journey">
                <div className="pointer-blue pointer-2">
                  <h4 className="font-avenirBook text-Gray-900 text-base">
                    2004
                  </h4>
                  <h4 className="font-avenirHeavy text-Gray-900 text-lg">
                    Expansion
                  </h4>
                  <p className="text-sm text-Gray-400 pt-3 font-opensans">
                    With the successful growth, 
                    we have started a service hub in{" "} 
                    <span className="font-bold">India</span>.
                  </p>
                </div>
              </div>
              <div className="rounded-lg bg-white my-2 px-6 py-4 shadow-xl border border-Gray-150 mobile-line-journey">
                <div className="pointer-pink pointer-4">
                  <h4 className="font-avenirBook text-Gray-900 text-base">
                    2015
                  </h4>
                  <h4 className="font-avenirHeavy text-Gray-900 text-lg">
                    Next Step
                  </h4>
                  <p className="text-sm text-Gray-400 pt-1 font-opensans">
                    By providing better digital solutions, 
                    we have successfully started an office branch in{" "} 
                    <span className="font-bold">Romania</span>.
                  </p>
                </div>
              </div>
              <div className="rounded-lg bg-white my-2 px-6 py-4 shadow-xl border border-Gray-150 mobile-line-journey">
                <div className="pointer-pink pointer-5">
                  <h4 className="font-avenirBook text-Gray-900 text-base">
                    2018
                  </h4>
                  <h4 className="font-avenirHeavy text-Gray-900 text-lg">
                    Evolution
                  </h4>
                  <p className="text-sm text-Gray-400 pt-1 font-opensans">
                    We have <span className="font-bold">20+</span> employees
                    with expertise and specialisation in several technologies
                    and platforms.
                  </p>
                </div>
              </div>
              <div className="rounded-lg bg-white mt-2 px-6 py-4 shadow-xl border border-Gray-150 mobile-line-journey">
                <div className="pointer-pink pointer-6">
                  <h4 className="font-avenirBook text-Gray-900 text-base">
                    2017
                  </h4>
                  <h4 className="font-avenirHeavy text-Gray-900 text-lg">
                    Diversity
                  </h4>
                  <p className="text-sm text-Gray-400 pt-1 font-opensans">
                    We are bringing brighter minds together around the world.
                    Now, we have <span className="font-bold">8</span> different
                    nationalities among us.
                  </p>
                </div>
              </div>
            </div>
            <>
              <div className="md:block lg:hidden hidden">
                <div className="grid grid-cols-1  md:grid-cols-5 gap-4 ">
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-blue pointer-1">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2001
                      </h4>
                      <h4 className="font-avenirBook text-Gray-900">
                        <span className="font-avenirHeavy">2M</span>Nordic
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        Company has been founded by{" "}
                        <span className="font-bold">Marius</span> and{" "}
                        <span className="font-bold">Mihai</span> in Helsinborg.
                      </p>
                    </div>
                  </div>
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150">
                    <div className="pointer-blue pointer-2">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2004
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Expansion
                      </h4>
                      <p className="text-xs text-Gray-400 pt-3 font-opensans">
                        With the successful growth, 
                        we have started a service hub in{" "} 
                        <span className="font-bold">India</span>.
                      </p>
                    </div>
                  </div>
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150">
                    <div className="pointer-pink pointer-4">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2015
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Next Step
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        By providing better digital solutions, 
                        we have successfully started an office branch in{" "} 
                        <span className="font-bold">Romania</span>.
                      </p>
                    </div>
                  </div>
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-pink pointer-5">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2018
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Evolution
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        We have <span className="font-bold">20+</span> employees
                        with expertise and specialisation in several
                        technologies and platforms.
                      </p>
                    </div>
                  </div>
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-pink pointer-6">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2017
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Diversity
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        We are bringing brighter minds together around the
                        world. Now, we have <span className="font-bold">8</span>{" "}
                        different nationalities among us.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative w-full journey-map-view hidden lg:block">
                <img
                  src={journeyLine}
                  alt=""
                  title=""
                  className="mx-auto relative z-50 "
                />
                <ScrollAnimation
                  animateIn="bounceIn"
                  className="bottom-2 l-4 absolute bottom-4 w-56 z-50"
                >
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150  mt-0 left-0 ">
                    <div className="pointer-blue pointer-1">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2001
                      </h4>
                      <h4 className="font-avenirBook text-Gray-900">
                        <span className="font-avenirHeavy">2M</span>Nordic
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        Company has been founded by{" "}
                        <span className="font-bold">Marius</span> and{" "}
                        <span className="font-bold">Mihai</span> in Helsinborg.
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation
                  animateIn="bounceIn"
                  className="absolute top-8 l-15 w-56 z-50"
                >
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-blue pointer-3">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2003
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        The beginning
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        We have opened a new office branch in{" "}
                        <span className="font-bold">Gothenburg</span> that
                        became main office.
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation
                  animateIn="bounceIn"
                  className=" absolute bottom-16 l-25 w-56 z-50"
                >
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-blue pointer-2">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2004
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Expansion
                      </h4>
                      <p className="text-xs text-Gray-400 pt-3 font-opensans">
                        With the successful growth, 
                        we have started a service hub in{" "} 
                        <span className="font-bold">India</span>.
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation
                  animateIn="bounceIn"
                  className="absolute b-10 l-55 w-56 z-50"
                >
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-pink pointer-4">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2015
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Next Step
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        By providing better digital solutions, 
                        we have successfully started an office branch in{" "} 
                        <span className="font-bold">Romania</span>.
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation
                  animateIn="bounceIn"
                  className="absolute bottom-36 r-5 w-56 z-50"
                >
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-pink pointer-5">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2018
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Evolution
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        We have <span className="font-bold">20+</span> employees
                        with expertise and specialisation in several
                        technologies and platforms.
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
                <ScrollAnimation
                  animateIn="bounceIn"
                  className="absolute -top-28 r-13 w-64 z-50"
                >
                  <div className="rounded-lg bg-white px-6 py-4 shadow-xl border border-Gray-150 ">
                    <div className="pointer-pink pointer-6">
                      <h4 className="font-avenirBook text-Gray-900 text-sm">
                        2017
                      </h4>
                      <h4 className="font-avenirHeavy text-Gray-900">
                        Diversity
                      </h4>
                      <p className="text-xs text-Gray-400 pt-1 font-opensans">
                        We are bringing brighter minds together around the
                        world. Now, we have <span className="font-bold">8</span>{" "}
                        different nationalities among us.
                      </p>
                    </div>
                  </div>
                </ScrollAnimation>
              </div>
            </>
          </div>
        </div>
      </section>
    </>
  );
};

export default Journey;
